import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';

import Icon from '../Icon';
import styles from './index.styles';

const BROWSER_LINK = 'https://www.google.com/intl/en/chrome/';

const BrowserSupportInfo = ({ intl: { formatMessage } }) => {
  return (
    <div
      className={cn(styles.formWrapper, styles.withPadding, 'tc items-center')}
    >
      <p className={styles.formTitle}>
        {formatMessage({ id: 'auth.browser.notSupport' })}
      </p>
      <div className={cn(styles.formDescription, 'mb3 f-12')}>
        {formatMessage({ id: 'auth.browser.newVersion' })}
      </div>
      <Icon name="chrome" size={32} />
      <a
        href={BROWSER_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(styles.link, 'mt2 f-12 db')}
      >
        {formatMessage({ id: 'auth.browser.getChrome' })}
      </a>
    </div>
  );
};

BrowserSupportInfo.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(BrowserSupportInfo);



// WEBPACK FOOTER //
// ./src/components/Auth/BrowserSupportInfo.jsx